import React from 'react';
import { observer } from 'mobx-react';
import Icon from '@mdi/react';
import { mdiAsterisk, mdiInformationOutline } from '@mdi/js';
import { StaticTooltip } from '../StaticTooltip/StaticTooltip';


interface IComboBox {
  label?: string;
  idAndName: string;
  initValue?: any;
  valid: boolean;
  required?: boolean;
  value: any;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: { target: any }) => void;
  onFocus?: (event: { target: any }) => void;
  options: IOption[];
  errorMsg: string;
  className?: string;
  requiredIcon?: boolean;
  infoIcon?: boolean;
  tooltipMessage?: string;
  infoIconCallback?: () => void;
  NoInitialBlankOption?: boolean;
  disabled?:boolean;
  wrapperName?: string;
  externalLabel?: string;
}
export interface IOption {
  name: string;
  value: any;
  optionDisabled?: boolean;
}

const ComboBoxComponent = (props: IComboBox) => {
  return (
    <div className={`common-combo-box-component${props.wrapperName ? ' ' + props.wrapperName : ''}`}>
      <label className="usa-label" htmlFor={props.idAndName}>
        {props.label}{props.required && props.requiredIcon ? <Icon path={mdiAsterisk} size={0.4} color="red" className='required-input-icon' /> : null}
        {props.infoIcon && props.infoIconCallback !== undefined ? (
          <Icon path={mdiInformationOutline } title={props.label} size={1} color="#005ea2" className='combo-box-info-icon ml-1' />
        ) : null}
        {props.tooltipMessage && props.infoIconCallback !== undefined ? (
          <StaticTooltip tooltipMessage={props.tooltipMessage} tooltipSide='right' id={`tooltip-${props.idAndName}`} />        
        ) : null}
      </label>
      <div className="usa-combo-box" data-default-value={props.initValue} data-filter=".*^{{query}}.*">
        <select
          data-testid="the-ComboBox"
          className={`usa-select ${props.className}`}
          name={props.idAndName}
          id={props.idAndName}
          aria-describedby={props.idAndName + '--err'}
          aria-invalid={!props.valid}
          aria-required={props.required}
          value={props.value}
          onChange={(e) => props.onChange(e)}
          onBlur={props.onBlur? (e) => props.onBlur!(e):undefined}
          disabled={props.disabled? props.disabled : false}
          aria-labelledby={props.externalLabel}
        >
          {props.NoInitialBlankOption ?
            null
            : <option value=""> - Select - </option>
          }



          {props.options.map((el, i) => (
            <option value={el.value} key={el.value} disabled={el.optionDisabled ? el.optionDisabled : false}>
              {el.name}
            </option>
          ))}
        </select>
      </div>
      <span className="usa-error-message" id={props.idAndName + '--err'} role="alert">
        {props.errorMsg}
      </span>
    </div>
  );
};

export const ComboBox = observer(ComboBoxComponent);
